import { ApiRequestHandler } from "../../shared-api/handlers/ApiRequestHandler";
import { Endpoints } from "../../fe-api/Endpoints"; // Ajuste o caminho de importação conforme sua estrutura
import { TipoVerba } from "../../constantes/Dominios";
import {IRequestConfig} from "../../shared-api/models/IRequestConfig";
import { TokenUtil } from "../../app/utils/Utils";
import {HTTPMethod} from "../../shared-api/enums/HTTPMethod";


// Tipagem do DTO que vem do Back-End
export interface IRemuneracaoListagem {
    id: number;
    dataCompetencia: string;
    tipoVerba: number;
    dataInclusao: string;
    usuarioAutenticadoID: number;
}

export class RemuneracaoService {
    
    async downloadPdf(competencia: string, tipoVerba: TipoVerba): Promise<{ blob: Blob, filename: string }> {
        // Usa a fonte única de verdade do sistema (Endpoints)
        // Passa a URL completa e os query params em forma de objeto
        return await ApiRequestHandler.getBlob(Endpoints.REMUNERACAO_DOWNLOAD, { competencia , tipoVerba});
    }

    /**
     * C - CREATE (Inserção)
     * Realiza o upload do arquivo PDF enviando os dados via FormData.
     */
    async uploadArquivo(file: File, competencia: string, tipoVerba: TipoVerba): Promise<void> {
        const formData = new FormData();
        formData.append("file", file);
        formData.append("competencia", competencia);
        formData.append("tipoVerba", String(tipoVerba));

        const customConfig: IRequestConfig = {
            getHeaders: () => ({
                'jwtPortal': TokenUtil.getToken(), // Injeta o token esperado no @RequestHeader do Back
                'Accept': 'application/json'
                // O Content-Type NÃO deve ser definido aqui para o navegador gerar o boundary do Multipart
            })
        };

        // Usa o método fetchVoid com POST
        await ApiRequestHandler.fetchVoid(HTTPMethod.POST, Endpoints.REMUNERACAO_UPLOAD, formData, customConfig);
    }

    /**
     * U - UPDATE (Atualização)
     * Substitui um arquivo existente utilizando a mesma lógica de FormData do upload, mas via PUT.
     */
    async atualizarArquivo(file: File, competencia: string, tipoVerba: TipoVerba): Promise<void> {
        const formData = new FormData();
        formData.append("file", file);
        formData.append("competencia", competencia);
        formData.append("tipoVerba", String(tipoVerba));

        const customConfig: IRequestConfig = {
            getHeaders: () => ({
                'jwtPortal': TokenUtil.getToken(),
                'Accept': 'application/json'
            })
        };

        // Usa o método fetchVoid com PUT
        await ApiRequestHandler.fetchVoid(HTTPMethod.PUT, Endpoints.REMUNERACAO_UPDATE, formData, customConfig);
    }

   /**
     * D - DELETE (Exclusão por Competência e Tipo de Verba)
     */
    async deletarArquivo(competencia: string, tipoVerba: TipoVerba): Promise<void> {
        // Monta a URL básica do endpoint
        const url = new URL(Endpoints.REMUNERACAO_DELETE);
        // Adiciona os parâmetros obrigatórios na URL query
        url.searchParams.append("competencia", competencia);
        url.searchParams.append("tipoVerba", String(tipoVerba));

        const customConfig: IRequestConfig = {
            getHeaders: () => ({
                'jwtPortal': TokenUtil.getToken(),
                'Accept': 'application/json'
            })
        };

        // Dispara o DELETE com corpo vazio usando a nossa estrutura padrão
        await ApiRequestHandler.fetchVoid(HTTPMethod.DELETE, url.toString(), null, customConfig);
    }
    
    /**
     * R - READ (Consulta/Listagem)
     * Busca a lista de todos os arquivos cadastrados (metadados apenas).
     */
    async listarArquivos(): Promise<IRemuneracaoListagem[]> {
        const customConfig: IRequestConfig = {
            getHeaders: () => ({
                'jwtPortal': TokenUtil.getToken(),
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            })
        };

        // Usa o método get padrão do seu handler, que já converte a resposta para JSON
        return await ApiRequestHandler.get(Endpoints.REMUNERACAO_LISTAR, undefined, customConfig);
    }
}